export const environment = {
    apiUrl: 'https://api.stage-eu.voxpopme.com',
    production: false,
    visualAnalysisUrl: 'http://localhost:3001',
};
